import { createFileRoute, redirect } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';

import { getEnv } from '@apple/utils/config/env';

import { validateToken } from '@apple/features/auth/api/authentication';
import { ResetPasswordPage } from '@apple/features/auth/pages/ResetPasswordPage';

const { APPLE_APP_TITLE } = getEnv();

export const Route = createFileRoute('/(public)/reset-password_/form')({
	component: ResetPasswordRoute,
	validateSearch: z.object({ token: z.string().optional() }),
	beforeLoad: ({ search }) => {
		if (!search.token) {
			throw redirect({ to: '/forgot-password', replace: true });
		}
		return { token: search.token };
	},
	loader: async ({ context: { token } }) => {
		const data = await validateToken(token);

		return { data: data };
	},
});

function ResetPasswordRoute() {
	const { data } = Route.useLoaderData();
	const navigate = Route.useNavigate();

	const navigateToResetPassword = useCallback(() => {
		void navigate({ to: '/forgot-password' });
	}, [navigate]);

	const navigateToMain = useCallback(() => {
		void navigate({ to: '/' });
	}, [navigate]);

	return (
		<ResetPasswordPage
			appName={APPLE_APP_TITLE}
			data={data}
			token={data.token}
			navigateToResetPassword={navigateToResetPassword}
			navigateToMain={navigateToMain}
		/>
	);
}
